import Skeleton from "react-loading-skeleton";

interface PackPriceProps {
  price: number | null | undefined;
  userPrice: number | null | undefined;
  loading: boolean;
}

const PackPrice = ({
  price,
  userPrice,
  loading,
}: PackPriceProps) => (
  <div className="w-full p-5 h-auto flex justify-between items-center bg-white">
    {loading ? (
      <Skeleton style={{ height: 20, width: 58 }} />
    ) : (
      <>
        <div className="text-black text-lg font-semibold">가격</div>
        <div className="flex items-center space-x-2">
          <div className="text-[#dadada] text-lg line-through">
            {price?.toLocaleString()}원
          </div>
          <div className="text-black text-lg font-bold">
            {userPrice?.toLocaleString()}원
          </div>
        </div>
      </>
    )}
  </div>
);

export default PackPrice;
